const MiniIntEditor = {
  props: {
    value: {},
    width: { type: [String, Number] }
  },
  model: { event: 'change' },
  computed: {
    styles () {
      return this.width ? { width: this.width + 'px' } : {}
    }
  },
  methods: {
    onKeyDown (e) {
      let code = e.keyCode, value = e.target.value;
      if (code == 13) {
        this.$emit('change', parseInt(value));
        // e.returnValue = false;
        return;
      }
      let pos = e.target.selectionStart;
      let b1 = (e.ctrlKey || e.metaKey) && (code == 67 || code == 86 || code == 88 || code == 65); // Ctrl/Command+[c、v、x、a]
      let b2 = (code >= 48 && code <= 57) || (code >= 96 && code <= 105) || code == 189; // 0-9,小键盘0-9，-
      let b3 = code >= 37 && code <= 40; // 左上右下
      let b4 = code == 8 || code == 9 || code == 16; // 回退、tab、Shift
      let minusIdx = value.indexOf('-');
      if ((!b1 && !b2 && !b3 && !b4) || (code == 189 && (pos != 0 || minusIdx != -1))) {
        e.returnValue = false;
      } else {
        this.$emit('keydown', e);
      }
    },
    onChange (e) {
      let value = e.target.value;
      if (value || value === 0 || value === '0') {
        value = parseInt(value);
      } else value = null;
      e.target.value = value;
      this.$emit('change', value);
    }
  },
  render (h) {
    return h('input', {
      domProps: { value: (this.value || this.value === 0 || this.value === '0') ? parseInt(this.value) : null },
      class: 'r-mini-editor',
      style: this.styles,
      on: {
        change: this.onChange,
        keydown: this.onKeyDown
      }
    })
  }
}
export default {
  install: function (Vue) {
    Vue.component('mini-int-editor', MiniIntEditor)
  }
}